import { CashFlow } from '@algoan/dashboard/model';

export const associateTransactionWithCashFlow = (cashFlows: CashFlow[] | undefined): { [key: string]: string } => {
  const transactionIdToCashFlowId: { [key: string]: string } = {};
  if (cashFlows) {
    cashFlows.forEach((cashFlow: CashFlow) => {
      cashFlow.transactions.forEach((transaction) => {
        transactionIdToCashFlowId[transaction.id] = cashFlow.id as string;
      });
    });
  }
  return transactionIdToCashFlowId;
};
